import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { BASE_URL } from "../../utils/baseURL";
import { setAlert } from "./alert.slice";
import axiosInstance from "../../utils/axiosInstance";
import Cookies from 'js-cookie';

const initialStateTechnician = {
    Technician: [],
    success: false,
    message: '',
    loading: false,
};

const handleErrors = (error, dispatch, rejectWithValue) => {
    const errorMessage = error.response?.data?.message || 'An error occurred';
    dispatch(setAlert({ text: errorMessage, color: 'error' }));
    return rejectWithValue(error.response?.data || { message: errorMessage });
};

export const getTechnician = createAsyncThunk(
    'technician/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const getuserId = localStorage.getItem("id");
            const response = await axiosInstance.get(BASE_URL + '/getAllTechnician/' + getuserId, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.technician;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const addTechnician = createAsyncThunk(
    'technician/add',
    async (data, { dispatch, rejectWithValue }) => {
        console.log(data, "data=====");
        try {
            const { technicianImage, MultipleImages, ...rest } = data;
            const formData = new FormData();

            formData.append('MultipleImages', JSON.stringify(MultipleImages));

            Object.keys(rest).forEach(key => {
                if (Array.isArray(rest[key])) {
                    rest[key].forEach(item => {
                        formData.append(key, item);
                    });
                } else {
                    formData.append(key, rest[key]);
                }
            });

            if (technicianImage) {
                technicianImage.forEach((file, index) => {
                    if (file instanceof File) {
                        formData.append('technicianImage', file);
                        formData.append(`technicianImageIndex_${formData.getAll('technicianImage').length - 1}`, index);
                    } else if (typeof file === 'string') {
                        formData.append(`ExistingtechnicianImage_${index}`, file);
                    }
                });
            }

            const response = await axiosInstance.post(BASE_URL + '/createTechnician', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            dispatch(getTechnician());
            return response.data.technician;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const deleteTechnician = createAsyncThunk(
    'technician/delete',
    async (id, { dispatch, rejectWithValue }) => {
        // console.log(id);
        try {
            const response = await axiosInstance.delete(`${BASE_URL}/deleteTechnician/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            dispatch(getTechnician());
            return id;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getTechnicianById = createAsyncThunk(
    'technician/view',
    async (id, { dispatch, rejectWithValue }) => {
        // console.log(id, "id");
        try {
            const response = await axiosInstance.get(`${BASE_URL}/getTechnicianById/${id}`, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            // console.log(response.data.Fabricator, "response.data.Fabricator");
            return response.data.technician;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const editTechnician = createAsyncThunk(
    'technician/edit',
    async (data, { dispatch, rejectWithValue }) => {
        console.log(data, "data=====");
        try {
            const { _id, MultipleImages, technicianImage, ...rest } = data;

            const formData = new FormData();
            formData.append('_id', _id);

            // Append all PaymentDetails, including existing ones

            formData.append('MultipleImages', JSON.stringify(MultipleImages));

            Object.keys(rest).forEach(key => {
                if (Array.isArray(rest[key])) {
                    rest[key].forEach(item => {
                        formData.append(key, item);
                    });
                } else {
                    formData.append(key, rest[key]);
                }
            });

            if (technicianImage) {
                technicianImage.forEach((file, index) => {
                    if (file instanceof File) {
                        // New file
                        formData.append('technicianImage', file);
                        formData.append(`technicianImageIndex_${formData.getAll('technicianImage').length - 1}`, index);
                    } else if (typeof file === 'string') {
                        // Existing file path
                        formData.append(`ExistingtechnicianImage_${index}`, file);
                    }
                });
            }

            const response = await axiosInstance.put(`${BASE_URL}/updateTechnician/${_id}`, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data',
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });

            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            dispatch(getTechnician());
            return response.data.technician;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);


export const updateTechnicianStatus = createAsyncThunk(
    'technician/updateTechnicianStatus',
    async ({ ids, submitDate }, { dispatch, rejectWithValue }) => {
        try {
            console.log("idfdssssss", ids);
            
            const response = await axiosInstance.post(`${BASE_URL}/updateTechnicianStatus`, {ids, submitDate }, {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            dispatch(setAlert({ text: response.data.message, color: 'success' }));
            // dispatch(getTechnician());
            return response.data.technician;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getInstallerInTech = createAsyncThunk(
    'InstallerInFab/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/getInstallerInTech', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            console.log("response.data", response.data);
            return response.data.assign;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);


export const getcategoryInTech = createAsyncThunk(
    'TechCategory/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/gettechCategory', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.category;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getsubcategoryInTech = createAsyncThunk(
    'TechsubCategory/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/gettechSubCategory', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.subCategory;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);

export const getproductInTech = createAsyncThunk(
    'Techproduct/get',
    async (_, { dispatch, rejectWithValue }) => {
        try {
            const response = await axiosInstance.get(BASE_URL + '/gettechProduct', {
                headers: {
                    Authorization: `Bearer ${Cookies.get("accessToken")}`
                }
            });
            return response.data.products;
        } catch (error) {
            return handleErrors(error, dispatch, rejectWithValue);
        }
    }
);



const technicianSlice = createSlice({
    name: 'technician',
    initialState: initialStateTechnician,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getTechnician.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Technicians...';
            })
            .addCase(getTechnician.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Technicians fetched successfully';
                state.Technician = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getTechnician.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Technicians';
            })
            .addCase(addTechnician.pending, (state) => {
                state.loading = true;
                state.message = 'Adding Technicians...';
            })
            .addCase(addTechnician.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.Technician.push(action.payload);
                state.message = action.payload?.message || 'Technician added successfully';
            })
            .addCase(addTechnician.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to add Technician';
            })
            .addCase(deleteTechnician.pending, (state) => {
                state.loading = true;
                state.message = 'Deleting Technician...';
            })
            .addCase(deleteTechnician.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.Technician = state.Technician.filter((technician) => technician._id !== action.payload);
                state.message = action.payload?.message || 'Technician deleted successfully';
            })
            .addCase(deleteTechnician.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to delete Technician';
            })
            .addCase(editTechnician.pending, (state) => {
                state.loading = true;
                state.message = 'Editing Technician...';
            })
            .addCase(editTechnician.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                if (Array.isArray(state.Technician)) {
                    state.Technician = state.Technician.map(technician =>
                        technician._id === action.payload?._id ? action.payload : technician
                    );
                }
                state.message = 'Technician updated successfully';
            })
            .addCase(editTechnician.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to update Technician';
            })
            .addCase(getTechnicianById.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Technician...';
            })
            .addCase(getTechnicianById.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Technician fetched successfully';
                state.Technician = action.payload;
            })
            .addCase(getTechnicianById.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Technician';
            })
            .addCase(updateTechnicianStatus.pending, (state) => {
                state.loading = true;
                state.message = 'Updating Technician Status...';
            })
            .addCase(updateTechnicianStatus.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Technician status updated successfully';
            })
            .addCase(updateTechnicianStatus.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to update Technician status';
            })
            .addCase(getInstallerInTech.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Fabricators...';
            })
            .addCase(getInstallerInTech.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Fabricators fetched successfully';
                state.assign = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getInstallerInTech.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Fabricators';
            })
            .addCase(getcategoryInTech.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Fabricators...';
            })
            .addCase(getcategoryInTech.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Fabricators fetched successfully';
                state.category = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getcategoryInTech.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Fabricators';
            })
            .addCase(getsubcategoryInTech.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Fabricators...';
            })
            .addCase(getsubcategoryInTech.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Fabricators fetched successfully';
                state.subCategory = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getsubcategoryInTech.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Fabricators';
            })
            .addCase(getproductInTech.pending, (state) => {
                state.loading = true;
                state.message = 'Fetching Fabricators...';
            })
            .addCase(getproductInTech.fulfilled, (state, action) => {
                state.loading = false;
                state.success = true;
                state.message = 'Fabricators fetched successfully';
                state.products = Array.isArray(action.payload) ? action.payload : [];
            })
            .addCase(getproductInTech.rejected, (state, action) => {
                state.loading = false;
                state.success = false;
                state.message = action.payload?.message || 'Failed to fetch Fabricators';
            })
    }
});

export default technicianSlice.reducer;